export default __webpack_public_path__ + "static/media/sword-battle.612630ff.svg";